import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { Component, OnInit, Output, EventEmitter, AfterViewInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/core/services/common.service';
import { BaseComponent } from '../../base/base.component';
import { PermissionConfig } from 'src/app/core/constants/permission-config';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/auth/auth.service';
import { Subscription, BehaviorSubject } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatDialog, DateAdapter } from '@angular/material';
import { ChangePasswordComponent } from '../../change-password/change-password.component';
import { ResponsiveService } from '../../../../core/services/responsive.service';
import { DEFAULT_FULL_PERMISSION_LIST, FeatureGroup } from 'src/app/core/constants/permission';
import { EnterpriseService } from 'src/app/core/services/enterprise.service';
import { EnterpriseConfigService } from 'src/app/core/services/enterprise-config.service';
import { Location } from '@angular/common';

declare function collapseSideBarJS(): any;
declare function collapseSideBarJSEventHover(): any;
declare var $: any;

@Component({
  selector: 'app-header-sidebar',
  templateUrl: './header-sidebar.component.html',
  styleUrls: ['./header-sidebar.component.scss']
})
export class HeaderSidebarComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  enterpriseRouter = [
    // Index[0]: Main
    //{link: '/home-enterprise/main', childPage: [], tagID: 'main'},
    { link: "/home-enterprise/analysis-report", childPage: [], tagID: "analysis-report" },

    // Index[1] - [3]: Document Management
    { link: '/home-enterprise/search-document', childPage: ['search-document'], tagID: 'menuDocumentManage' },
    { link: '/home-enterprise/search-document-receive', childPage: ['search-document-receive'], tagID: 'menuDocumentManage' },
    { link: '/home-enterprise/search-unprocessed-document', childPage: ['search-unprocessed-document'], tagID: 'menuDocumentManage' },

    // Index[4] - [8]: My Document Management
    { link: '/home-enterprise/add-document', childPage: [], tagID: 'menuMyDocument' },
    { link: '/home-enterprise/search-my-created-document', childPage: ["/home-enterprise/view-document", "/home-enterprise/update-document"], tagID: 'menuMyDocument' },
    { link: '/home-enterprise/search-document-sign', childPage: ['search-document-sign'], tagID: 'menuMyDocument' },
    { link: '/home-enterprise/search-approval-waiting-document', childPage: ['search-approval-waiting-document'], tagID: 'menuMyDocument' },
    { link: '/home-enterprise/search-initial-waiting-document', childPage: ['search-initial-waiting-document'], tagID: 'menuMyDocument' },


    // Index[9] - [16]: Enterprise Management
    // { link: "/home-enterprise/enterprise/update", childPage: [], tagID: "menuEnterpriseInfo" },
    { link: "/home-enterprise/view-enterprise", childPage: [], tagID: "menuEnterpriseInfo" },
    { link: "/home-enterprise/digital-certificate", childPage: [], tagID: "menuGeneralConfig" },
    { link: "/home-enterprise/branches", childPage: ["/home-enterprise/add-branch", "/home-enterprise/update-branch"], tagID: "menuEnterpriseInfo" },
    { link: "/home-enterprise/user-group", childPage: ['/home-enterprise/add-user-group', '/home-enterprise/autho-user-group'], tagID: "menuEnterpriseInfo" },
    { link: "/home-enterprise/user", childPage: [], tagID: "menuEnterpriseInfo" },
    { link: "/home-enterprise/customers", childPage: ["/home-enterprise/update-customer", "/home-enterprise/view-customer", , "/home-enterprise/result-sync-customer"], tagID: "menuManagementCustomer" },
    { link: '/home-enterprise/document-group-manage', childPage: ['/home-enterprise/add-document-group-v2', '/home-enterprise/config-general-manage', '/home-enterprise/synchronize-document-group'], tagID: 'menuGeneralConfig' },
    { link: "/home-enterprise/document-type", childPage: ["/home-enterprise/add-document-type-list"], tagID: "menuEnterpriseInfo" },

    // Index[17] - [22]: Report Management
    {link: '/home-enterprise/total-contract-report', childPage: [], tagID: 'menuReportManage'},
    {link: '/home-enterprise/sms-quantity-report', childPage: [], tagID: 'menuReportManage'},
    {link: '/home-enterprise/sms-money-report', childPage: [], tagID: 'menuReportManage'},
    {link: '/home-enterprise/contract-enterprise-create', childPage: [], tagID: 'menuReportManage'},
    {link: '/home-enterprise/contract-personal-create', childPage: [], tagID: 'menuReportManage'},
    {link: '/home-enterprise/contract-enterprise-receive', childPage: [], tagID: 'menuReportManage'},

    // Index 23: Document type template demo in Enterprise Management
    { link: "/home-enterprise/document-template", childPage: [], tagID: "menuGeneralConfig" },

    // Index 24: General category template in Enterprise Management
    { link: "/home-enterprise/general-category", childPage: [], tagID: "menuGeneralConfig" },

     // Index 25: Procedure management
     { link: "/home-enterprise/procedure-management", childPage: [], tagID: "menuGeneralConfig" },

     // Menu User Config
     // Index 26: Procedure management
     { link: "/home-enterprise/usr-procedure-management", childPage: [], tagID: "menuUserConfig" },
    // { link: "/home-enterprise/general-category", childPage: [], tagID: "menuEnterpriseInfo" },

    // Index [27] - [29]: Enterprise Management
    { link: '/home-enterprise/search-my-receive-document', childPage: ["/home-enterprise/view-document", "/home-enterprise/update-document"], tagID: 'menuMyDocument' },
    { link: "/home-enterprise/department", childPage: [], tagID: "menuEnterpriseInfo" },
    { link: '/home-enterprise/digital-contract', childPage: ['digital-contract'], tagID: 'menuMyDocument'},

    // Index [30] - [31]: Bonus Report Management
    {link: '/home-enterprise/certificate-money-report', childPage: [], tagID: 'menuReportManage'},
    {link: '/home-enterprise/timestamp-quantity-report', childPage: [], tagID: 'menuReportManage'},

    // Index 32: Add Customer
    {link: '/home-enterprise/add-customer', childPage: [], tagID: 'menuManagementCustomer'},
    {link: '/home-enterprise/group-customers', childPage: ['/home-enterprise/manage-group-customers', '/home-enterprise/create-group-customers'], tagID: 'menuManagementCustomer'},
    {link: '/home-enterprise/export-data-customer', childPage: [], tagID: 'menuManagementCustomer'},

    // Index 35: Enterprise Config
    {link: '/home-enterprise/enterprise-config', childPage: [], tagID: 'menuGeneralConfig'},

    // Index 36: My Document Management - enterprise_waiting_confirm_doc
    { link: '/home-enterprise/search-waiting-confirm-document', childPage: ['search-waiting-confirm-document'], tagID: 'menuMyDocument' },
    // Index 37: Enterprise Management
    { link: '/home-enterprise/digital-business', childPage: ['digital-contract-business'], tagID: 'menuDocumentManage'},
    // Index 38 : report number of contract set user
    { link: '/home-enterprise/contract-user-report', childPage: [], tagID: 'menuReportManage' }, // Index 39: Enterprise Config notification
    // Index 39: Enterprise Config notification
    { link: '/home-enterprise/enterprise-notification', childPage: [], tagID: 'menuGeneralConfig' },
    // Index 41: Enterprise Action Log
    { link: '/home-enterprise/enterprise-action-log', childPage: [], tagID: 'menuEnterpriseInfo'},
    // Index 40: add document quickly
    { link: '/home-enterprise/add-contract-quickly', childPage: [], tagID: 'menuMyDocument' },
    // Index 42: Search Processing Contract
    { link: '/home-enterprise/search-processing-document', childPage: [], tagID: 'menuMyDocument'},
    // Index 43: Search Negotiate Contract
    { link: '/home-enterprise/search-negotiate-document', childPage: [], tagID: 'menuMyDocument'},
    // Index 44: Search Contract Share Partner
    { link: '/home-enterprise/search-document-share-partner', childPage: ['search-document-share-partner'], tagID: 'menuDocumentManage'},
    // Index 45: Search Processing Contract Report
    { link: '/home-enterprise/contract-processing', childPage: [], tagID: 'menuReportManage'},
    // Index 46: Configure the labor utilization Report
    { link: '/home-enterprise/labor-utilization-report', childPage: [], tagID: 'menuGeneralConfig'},
    // Index 47: add document moha
    { link: '/home-enterprise/new-document-moha', childPage: [], tagID: 'menuMyContract' },
    // Index 48: Search Processing Contract Report
    { link: '/home-enterprise/search-document-contract-company', childPage: ['search-document-contract-company'], tagID: 'menuDocumentManage' },
    // Index 49: add document digital contract employment
    { link: '/home-enterprise/contract-digitzation-moha', childPage: ['contract-digitzation-moha', '/home-enterprise/sign-digital-flow'], tagID: 'menuMyContract' },
    // Index 50: Sms-History-Report
    { link: '/home-enterprise/sms-history-report/analysis-report', childPage: [], tagID: 'menuReportManage' },
    // Index 51: approved contract moha
    { link: '/home-enterprise/approved-contract-moha', childPage: ['approved-contract-moha'], tagID: 'menuMyContract' },
    // Index 52: Share resource
    { link: '/home-enterprise/share-resource', childPage: [], tagID: 'menuGeneralConfig'},
    // Index 53: search document sign digital
    { link: '/home-enterprise/digital-search-document', childPage: ['digital-search-document'], tagID: 'menuMyContract' },
    // Index 54: search approval waiting document digital
    { link: '/home-enterprise/search-approval-waiting-document-digital', childPage: ['search-approval-waiting-document-digital'], tagID: 'menuMyContract' },
  ];

  //Định nghĩa quyền truy cập vào các router trong hệ thống.
  // route: định nghĩa đường dẫn đích.
  // accessRight: định nghĩa -> loại người dùng (userType), -> nhóm quyền có thể vào (permissons), -> có cha mẹ hay không (checkParent).
  // isShowMobile: định nghĩa route đó có hiển thì trên mobile hay không? true : có; false: không
  routeAccessRights = [
    {
      route: '/home-enterprise/sms-history-report/analysis-report',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.MANAGE_ENTERPRISE],
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/analysis-report',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/enterprise/update',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [1],
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: [1],
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/view-enterprise',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [1],
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: [1],
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/add-customer',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/export-data-customer',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.MANAGE_CUSTOMER],
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/customers',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/group-customers',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.MANAGE_CUSTOMER],
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/procedure-management',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/usr-procedure-management',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/document-type',
      accessRight: [
        {
          userType: 0,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [1],
          checkParent: false
        }
      ],
      isShowMobile: true
    }
    , {
      route: '/home-enterprise/document-template',
      accessRight: [
        {
          userType: 0,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [1],
          checkParent: false
        }
      ],
      isShowMobile: true
    }
    ,{
      route: '/home-enterprise/digital-certificate',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [1],
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: [1],
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/branches',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: true
        },
        {
          userType: 2,
          permissons: [1],
          checkParent: true
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/department',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [2],
          checkParent: false
        },
        // {
        //   userType: 3,
        //   permissons: DEFAULT_FULL_PERMISSION_LIST,
        //   checkParent: false
        // },
        {
          userType: 4,
          permissons: [2],
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/user-group',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [2],
          checkParent: false
        }
        // ,
        // {
        //   userType: 3,
        //   permissons: DEFAULT_FULL_PERMISSION_LIST,
        //   checkParent: false
        // }
        , {
          userType: 4,
          permissons: [2],
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/user',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [2],
          checkParent: false
        },
        // {
        //   userType: 3,
        //   permissons: DEFAULT_FULL_PERMISSION_LIST,
        //   checkParent: false
        // },
        {
          userType: 4,
          permissons: [2],
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/add-document',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: false
    },
    {
      route: '/home-enterprise/search-document',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.CREATE_SIDE_DOCUMENT],
          checkParent: false
        }
        // {
        //   userType: 4,
        //   permissons: [7],
        //   checkParent: false
        // },
        // {
        //   userType: 5,
        //   permissons: DEFAULT_FULL_PERMISSION_LIST,
        //   checkParent: false
        // }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/search-document-sign',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/search-document-receive',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.RECEIVE_SIDE_DOCUMENT],
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: [FeatureGroup.SIGN],
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/search-my-created-document',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/digital-search-document',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/search-approval-waiting-document-digital',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/search-my-receive-document',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/search-approval-waiting-document',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/search-initial-waiting-document',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/search-waiting-confirm-document',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/search-waiting-temp-sign-document',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/document-group-manage',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: true
        },
        {
          userType: 2,
          permissons: [1],
          checkParent: true
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/total-contract-report',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.MANAGE_ENTERPRISE],
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/sms-quantity-report',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.MANAGE_ENTERPRISE],
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/sms-money-report',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.MANAGE_ENTERPRISE],
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/contract-enterprise-create',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.CREATE_SIDE_DOCUMENT],
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/contract-personal-create',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/contract-enterprise-receive',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.RECEIVE_SIDE_DOCUMENT],
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: [FeatureGroup.SIGN],
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/general-category',
      accessRight: [
        {
          userType: 0,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [1],
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/digital-contract',
      accessRight: [
        {
          userType: 1,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 3,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 4,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 5,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/digital-business',
      accessRight: [
        {
          userType: 1,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 3,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 4,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        },
        {
          userType: 5,
          permissons: [FeatureGroup.DIGITAL_CONTRACT],
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/certificate-money-report',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.MANAGE_ENTERPRISE],
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/contract-user-report',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/timestamp-quantity-report',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.MANAGE_ENTERPRISE],
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/enterprise-config',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: true
        },
        {
          userType: 2,
          permissons: [1],
          checkParent: true
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/enterprise-notification',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: true
        },
        {
          userType: 2,
          permissons: [1],
          checkParent: true
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/search-processing-document',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/search-negotiate-document',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/search-document-share-partner',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [13,1301],
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/contract-processing',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/share-resource',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/contract-digitzation-moha',
      accessRight: localStorage.getItem('isApplyContractMoha') === 'true' ? [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [12],
          checkParent: false
        }
      ] : [],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/new-document-moha',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [12],
          checkParent: false
        }
      ],
      isShowMobile: true
    },
    {
      route: '/home-enterprise/approved-contract-moha',
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        }
      ],
      isShowMobile: false
    },
    {
      route: '/home-enterprise/search-document-contract-company',
      accessRight: localStorage.getItem('isApplyContractMoha') === 'true' ? [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [FeatureGroup.CREATE_SIDE_DOCUMENT],
          checkParent: false
        }
      ] : [],
      isShowMobile: true
    },
  ];

  currentLink = this.enterpriseRouter[0].link;
  currentTagID = this.enterpriseRouter[0].tagID;
  isDisplayMenuManageBranch: boolean = false;
  HOME_PAGE_INDEX = 0;

  userType: any;
  token: string;
  permissions: any = '';
  isPermisEnterprise: boolean;
  isPermisInfoEnterprise: boolean;
  isPermissDocument: boolean;
  isPermissionInfo: boolean;
  isParent: any;

  // Save Sidebar toggle status through navigation
  stopSidebarToggleEventDuringInitializing = true;
  SIDEBAR_CURRENT_STATUS = 'SidebarCurrentStatus';
  EXPANDED = 'Expanded';
  COLLAPSED = 'Collapsed';
  isExpandingMenuItemsOfCurrentMenu = false;

  // uer type
  userSysAdminType = PermissionConfig.USER_SYS_ADMIN_TYPE; // 0
  userEnterpriseAdminType = PermissionConfig.USER_ENTERPRISE_ADMIN_TYPE; // 1
  userEnterpriseStaffType = PermissionConfig.USER_ENTERPRISE_STAFF_TYPE; // 2
  userEnterpriseCustomerType = PermissionConfig.USER_ENTERPRISE_CUSTOMER_TYPE; // 3
  userEnterpriseDocument = PermissionConfig.USER_ENTERPRISE_DOCUMENT; // 5
  userPersonalAdminType = PermissionConfig.USER_ENTERPRISE_DOCUMENT; // 5
  userWaitingDocument = PermissionConfig.USER_WAITING_DOCUMENT; // 6

  // feature groups
  enAdminEnterpriseInfoManage = PermissionConfig.EN_ADMIN_ENTERPRISE_INFO_MANAGE; // 1
  enAdminCetificateManage = PermissionConfig.EN_CETIFICATE; // 1
  enAdminBranchManage = PermissionConfig.EN_ADMIN_BRANCH_MANAGE; // 3
  enManagerDoc = PermissionConfig.EN_MANAGER_DOC; // 3
  enAdminGroupUserManage = PermissionConfig.EN_ADMIN_GROUP_USER_MANAGE; // 4
  enAdminUserManage = PermissionConfig.EN_ADMIN_USER_MANAGE; // 2
  enAdminMaterialSampleManage = PermissionConfig.EN_ADMIN_MATERIAL_SAMPLE_MANAGE; // 6
  enAdminCustomerManage = PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE; // 7
  enAdminMaterialManage = PermissionConfig.EN_ADMIN_MATERIAL_MANAGE; // 8
  sysAdminEnterpriseInfoManage = PermissionConfig.SYS_ADMIN_ENTERPRISE_INFO_MANAGE; // 9
  sysAdminUserManage = PermissionConfig.SYS_ADMIN_USER_MANAGE; // 10
  sysAdminMaterialSampleManage = PermissionConfig.SYS_ADMIN_MATERIAL_SAMPLE_MANAGE; // 11

  private subscribeSidebar: Subscription;
  menuDocumentSignActive = false;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;

  isNotAttestedUser: boolean = false;

  entType: any;
  /**
   * <pre>
   * <b>Method name: constructor</b>
   * <b>Explanation: </b> Method constructor
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  constructor(
    public commonService: CommonService,
    private router: Router,
    private auth: AuthenticationService,
    private translate: TranslateService,
    private authService: AuthService,
    public message: Message,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    public deviceService: DeviceDetectorService,
    private responsiveService: ResponsiveService,
    private enterpriseService: EnterpriseService,
    private enterpriseConfigService: EnterpriseConfigService,
    public location: Location,
    private dialog: MatDialog,
  ) {
    super(commonService, message);
    this.userType = localStorage.getItem('userType');
    this.token = this.authService.getToken();
    this.entType = localStorage.getItem('entType');
    this.permissions = localStorage.getItem('permissions') || '';
    this.isParent = localStorage.getItem('isParent');
    this.showPermisInfoEnterprise();
    this.showPermisEnterprise();
    this.showPermissDocument();
    this.showPermissionInfo();
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
  }

  ngOnDestroy(): void {
    if (this.subscribeSidebar != null) {
      this.subscribeSidebar.unsubscribe();
    }
    if(this.subscribeMediaBreakPointService.unsubscribe() != null){
    this.subscribeMediaBreakPointService.unsubscribe();
    }
  }

  @Output() changeLanguage = new EventEmitter<boolean>();

  ngOnInit() {
    this.checkPermissionManageBranch();
    this.commonService.sidebarSubscription = new BehaviorSubject<any>('');
    this.initSelectedMenuByTheUrl();
  }

  ngAfterViewInit(): void {
    this.initSidebarStatusAfterLoad();
    collapseSideBarJSEventHover();
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
        }
      }
    );
  }

  //thực hiện xử lý khi điều hướng chuyển router load view
  //nếu menu ở trạng thái COLLAPSED thì luôn thu menu và ngược lại thì luôn mở rộng menu
  private initSidebarStatusAfterLoad() {
    // if (localStorage.getItem(this.SIDEBAR_CURRENT_STATUS) == this.COLLAPSED) {
      //Tự động thu menu. (24763 fix loi khi click vao menu chuyen man thi auto mo rong man hinh)
      // document.getElementById('sidebarToggle').click();
    // } else {
      if (localStorage.getItem(this.SIDEBAR_CURRENT_STATUS) != this.COLLAPSED) {
        //Tự động mở rộng menu theo tagID.
        if (this.currentTagID != this.enterpriseRouter[0].tagID) {
          if(document.getElementById(this.currentTagID))
            this.expandSubmenu(this.currentTagID);
        }
      }

    this.stopSidebarToggleEventDuringInitializing = false;
  }

  //Mở submenu ngay khi render (set class) thay vì .click() -> tránh hiệu ứng
  //dropdown bị đóng rồi mở lại bằng animation sau mỗi lần điều hướng
  //Lưu ý: enterprise-sidebar và header-sidebar cùng DOM và trùng id menu,
  //nên phải chọn theo [id=...] (all matches) thay vì $('#id') (chỉ match đầu tiên)
  private expandSubmenu(menuID: string) {
    $('[id="' + menuID + '"]').each(function () {
      const $menu = $(this);
      const $collapse = $menu.next('.collapse');
      if ($collapse.length && !$collapse.hasClass('show')) {
        $collapse.addClass('show');
        $menu.removeClass('collapsed');
        $menu.attr('aria-expanded', 'true');
      }
    });
  }

  initSelectedMenuByTheUrl() {
    const url = this.router.url;
    // console.log("this.enterpriseRouter: ", this.enterpriseRouter);
    // var goFrom = "";

    this.route.queryParams.subscribe(params => {
      let goFrom = params['goFrom'] || null;
      if (goFrom != null && this.router.url.includes('/home-enterprise/view-document')) {
        // this.hasParam = true;
        this.setMenuActiveForViewDocument(goFrom);
      } else {
        // this.hasParam = false;
        this.setMenuActiveWithLocalStorage();
      }
    });
    // this.setMenuActiveWithLocalStorage();

    if (url.includes(this.enterpriseRouter[15].childPage[0])) {
      this.setCurLinkTagID(15);
      return;
    }

    // Special case: If an URL cover another one, must check it first
    // 'search-document-sign' cover 'search-document'
    if (url.includes(this.enterpriseRouter[6].link)
      || url.includes(this.enterpriseRouter[6].childPage[0])) {
      this.setCurLinkTagID(6);
      return;
    }

    // 'search-document-receive' cover 'search-document'
    if (url.includes(this.enterpriseRouter[2].link)
      && url.includes(this.enterpriseRouter[2].childPage[0])) {
      this.setCurLinkTagID(2);
      return;
    }

    // 'contract-digitization' cover 'search-document'
    if (url.includes(this.enterpriseRouter[29].link)
      && url.includes(this.enterpriseRouter[29].childPage[0])) {
      this.setCurLinkTagID(29);
      return;
    }

    if (url.includes(this.enterpriseRouter[44].link)
      || url.includes(this.enterpriseRouter[44].childPage[0])) {
      this.setCurLinkTagID(44);
      return;
    }

    if (url.includes(this.enterpriseRouter[48].link)
      || url.includes(this.enterpriseRouter[48].childPage[0])) {
      this.setCurLinkTagID(48);
      return;
    }

    if (url.includes(this.enterpriseRouter[49].link)
      || url.includes(this.enterpriseRouter[49].childPage[0])) {
      this.setCurLinkTagID(49);
      return;
    }

    if (url.includes(this.enterpriseRouter[51].link)
      || url.includes(this.enterpriseRouter[51].childPage[0])) {
      this.setCurLinkTagID(51);
      return;
    }

    if (url.includes(this.enterpriseRouter[53].link)
      || url.includes(this.enterpriseRouter[53].childPage[0])) {
      this.setCurLinkTagID(53);
      return;
    }

    if (url.includes(this.enterpriseRouter[54].link)
      || url.includes(this.enterpriseRouter[54].childPage[0])) {
      this.setCurLinkTagID(54);
      return;
    }
    // // 'add-document-type-list' cover 'add-document'
    // if (url.includes(this.enterpriseRouter[3].childPage[0])) {
    //   this.setCurLinkTagID(3);
    //   return;
    // }

    // 'search-document-receive' cover 'search-document'
    // if (url.includes(this.enterpriseRouter[12].link)) {
    //   this.setCurLinkTagID(goFrom === "receive" ? 11 : 11);
    //   return;
    // }
    // 'add-document-type-list' cover 'add-document'

    // if (url.includes(this.enterpriseRouter[12].childPage[0])) {
    //   this.setCurLinkTagID(12);
    //   return;
    // }

    // if (url.includes(this.enterpriseRouter[5].childPage[0])) {
    //   this.setCurLinkTagID(5);
    //   return;
    // }

    // Set current link, tagID by the url
    for (let i = this.HOME_PAGE_INDEX + 1; i < this.enterpriseRouter.length; i++) {
      // Check in links
      if (url.includes(this.enterpriseRouter[i].link)) {
        this.setCurLinkTagID(i);
        break;
      }
      // Check in child pages
      this.enterpriseRouter[i].childPage.forEach(element => {
        if (url.includes(element)) {
          this.setCurLinkTagID(i);
        }
      });
      // End if current tagID has changed
      if (this.currentTagID != this.enterpriseRouter[this.HOME_PAGE_INDEX].tagID) {
        break;
      }
    }
  }

  private setMenuActiveWithLocalStorage() {
    this.subscribeSidebar = this.commonService.sidebarSubscription.subscribe(dcResponse => {
      if (dcResponse != "" && !this.menuDocumentSignActive) {
        console.log(this.menuDocumentSignActive);
        console.log(dcResponse);
        let tagId = 11;
        if (dcResponse.creatorSide) {
          tagId = 9;
        }
        this.setCurLinkTagID(tagId);
      }
    });
  }

  private setCurLinkTagID(routerIndex: number) {
    this.currentLink = this.enterpriseRouter[routerIndex].link;
    this.currentTagID = this.enterpriseRouter[routerIndex].tagID;
  }

  private setMenuActiveForViewDocument(goFrom: any) {
    if (goFrom == 'receive') {            // Hợp đồng nhận từ đối tác
      this.setCurLinkTagID(2);
    } else if (goFrom == 'waitSign') {    // Hợp đồng chờ ký
      this.setCurLinkTagID(6);
    } else if (goFrom == 'waitApprove') { // Hợp đồng chờ phê duyệt
      this.setCurLinkTagID(7);
    } else if (goFrom == 'waitInitial') { // Hợp đồng chờ ký nháy
      this.setCurLinkTagID(8);
    } else if (goFrom == 'mine') {        // Hợp đồng tôi lập
      this.setCurLinkTagID(5);
    } else if (goFrom == 'mineReceive') {        // Hợp đồng tôi nhận
      this.setCurLinkTagID(27);
    } else if (goFrom === 'digitization') {     // Số hóa hợp đồng
      this.setCurLinkTagID(29);
    } else if(goFrom === 'negotiate'){
      this.setCurLinkTagID(43);
    } else if(goFrom === 'share'){
      this.setCurLinkTagID(44);
    } else if(goFrom === 'hdld'){
      this.setCurLinkTagID(47);
    }  else if(goFrom === 'enterprise_company'){
      this.setCurLinkTagID(48);
    } else if(goFrom === 'digitalMyEmployment'){
      this.setCurLinkTagID(49);
    } else if(goFrom === 'waitSignMoha'){
      this.setCurLinkTagID(51);
    }
    else {                              // Hợp đồng công ty lập
      this.setCurLinkTagID(1);
    }
  }

  /**
   * <pre>
   * <b>Method name: logout</b>
   * <b>Explanation: </b> Method logout
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  logout() {
    this.auth.logout();
    this.router.navigate(['enterprise-login']);
  }

  /**
   * <pre>
   * <b>Method name: onChangeLanguage</b>
   * <b>Explanation: </b> Method setting change langauge
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  onChangeLanguage(languageSelected: string) {
    if (languageSelected == 'en') {
      this.toastr.info(this.message.getMessage('messages.english_not_supported'));
    } else {
      this.setLanguagelocalStored(languageSelected);
      this.translate.use(this.getLanguagelocalStored());
      this.checkIconLanguage(this.getLanguagelocalStored());
    }
  }

  /**
   * <pre>
   * <b>Method name: showPermisInfoEnterprise</b>
   * <b>Explanation: </b> Method setting enterprise info menu
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  showPermisInfoEnterprise() {
    if (this.userType == PermissionConfig.USER_ENTERPRISE_ADMIN_TYPE || this.userType == PermissionConfig.USER_ENTERPRISE_CUSTOMER_TYPE
      || (this.permissions.includes(PermissionConfig.EN_ADMIN_BRANCH_MANAGE) && this.isParent == 'true')
      || this.permissions.includes(PermissionConfig.EN_ADMIN_GROUP_USER_MANAGE)
      || this.permissions.includes(PermissionConfig.EN_ADMIN_USER_MANAGE)) {
      this.isPermisEnterprise = true;
    } else {
      this.isPermisEnterprise = false;
    }
  }

  /**
   * <pre>
   * <b>Method name: showPermisEnterprise</b>
   * <b>Explanation: </b> Method setting enterprise menu
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  showPermisEnterprise() {
    if (this.userType == PermissionConfig.USER_ENTERPRISE_ADMIN_TYPE || this.userType == PermissionConfig.USER_ENTERPRISE_CUSTOMER_TYPE
      || this.userType == this.userPersonalAdminType
      || this.permissions.includes(PermissionConfig.EN_ADMIN_ENTERPRISE_INFO_MANAGE)
      || this.permissions.includes(PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE)) {
      this.isPermisInfoEnterprise = true;
    } else {
      this.isPermisInfoEnterprise = false;
    }
  }

  showPermissionInfo() {
    if ((this.permissions.includes(this.enAdminUserManage)) && (this.userType == 4)
      || (this.permissions.includes(this.enAdminMaterialSampleManage)) && (this.userType == 4)) {
      this.isPermissionInfo = true;
    } else {
      this.isPermissionInfo = false;
    }
  }

  showPermissDocument() {
    if (this.userType == PermissionConfig.USER_ENTERPRISE_ADMIN_TYPE || this.userType == PermissionConfig.USER_ENTERPRISE_STAFF_TYPE
      || this.userType == PermissionConfig.USER_ENTERPRISE_CUSTOMER_TYPE
      || (this.userType == PermissionConfig.USER_CUSTOMER_ENTERPRISE && this.permissions.includes(PermissionConfig.EN_ADMIN_DOCUMENT))
      || this.userType == PermissionConfig.USER_ENTERPRISE_DOCUMENT) {
      this.isPermissDocument = true;
    } else {
      this.isPermissDocument = false;
    }
  }

  collapseSideBar() {
    collapseSideBarJS();
    if (!this.stopSidebarToggleEventDuringInitializing) {
      // Check is expanding sidebar then update sidebar current status
      if (localStorage.getItem(this.SIDEBAR_CURRENT_STATUS) == this.COLLAPSED) {
        localStorage.setItem(this.SIDEBAR_CURRENT_STATUS, this.EXPANDED);
        // Expand menu after sidebar expanded
        if (this.currentTagID != this.enterpriseRouter[0].tagID
          && !this.isExpandingMenuItemsOfCurrentMenu) {
          document.getElementById(this.currentTagID).click();
        }
      } else {
        localStorage.setItem(this.SIDEBAR_CURRENT_STATUS, this.COLLAPSED);
        this.isExpandingMenuItemsOfCurrentMenu = false;
      }
    }

    //hover
    collapseSideBarJSEventHover();
  }

  /**
   * To know is the current menu is expanding while sidebar is collapsing
   * @param menuID the id of menu
   */
  public onMenuClick(menuID: string) {
    // console.log(menuID)
    if (localStorage.getItem(this.SIDEBAR_CURRENT_STATUS) == this.COLLAPSED) {
      // If click current menu when collapsing => switch stat.
      // If click on other menu => false
      if (menuID == this.currentTagID) {
        //this.isExpandingMenuItemsOfCurrentMenu = !this.isExpandingMenuItemsOfCurrentMenu;
      } else {
        this.isExpandingMenuItemsOfCurrentMenu = false;
      }
    }
  }

  getAccessRights(route: string) {
    this.userType = Number(localStorage.getItem('userType'));
    this.permissions = JSON.parse(localStorage.getItem('permissions')) || '';
    this.isParent = localStorage.getItem('isParent');
    let routeAccess;

    //Nếu là desktop, tablet thì lấy ra các route bình thường.
    if (this.mediaBreakpoint !== SCREEN_SIZE.SM && this.mediaBreakpoint !== SCREEN_SIZE.XS) {
      routeAccess = this.routeAccessRights.find(x => x.route == route);
    } else { // Nếu là mobile thì chỉ lấy ra những route có isShowMobile = true.
      routeAccess = this.routeAccessRights.find(x => x.route == route && x.isShowMobile == true);
    }

    // console.log("userType: ", this.userType);
    // console.log("permissions: ", this.permissions);
    // console.log("isParent: ", this.isParent);
    // console.log("routeAccess: ", routeAccess);

    if (!routeAccess) {
      return false;
    } else {
      const allowedUser = routeAccess.accessRight.find(x => x.userType == this.userType);
      if (allowedUser && (allowedUser.userType > 0 && allowedUser.permissons.some(x => this.permissions.indexOf(x) >= 0))) {
        //kiểm tra nếu user đó có cha mẹ hay không?
        if (allowedUser.checkParent && this.isParent != 'true') {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  }

  checkPermissionManageBranch() {
    const enterpriseId = localStorage.getItem('enterpriseId');
    this.enterpriseConfigService.getConfig(enterpriseId).subscribe(res => {
      if(res && res.success){
        this.isDisplayMenuManageBranch = res.data.enableManageBranch;
      }
    })
  }

  eventCheckPermissionBranch() {
    const enterpriseId = localStorage.getItem('enterpriseId');
    // re-validate khi click menu: fetch mới, không dùng cache
    this.enterpriseService.getPermissionManageBranch(enterpriseId).subscribe(res => {
      if(res && res.success){
        if(res.data.enableManageBranch == false) {
          this.toastr.error(this.message.getMessage('messages.no_permission'));
          this.location.back();
        } else this.router.navigate([this.enterpriseRouter[11].link]);
      }
    })
  }

  changePassword() {
    document.getElementById('toggleBar').click();
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      width: this.deviceService.isMobile() ? '100%' : '50%',
      maxWidth: this.deviceService.isMobile() ? '90vw' : '80vw',
      panelClass: 'scontract-overlay-dialog',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(() => {
    });
  }
}
